import { dynamicSort } from '@/shared/utils/dynamicSort';
import angular from 'angular';

angular.module('cloudX').directive('cxUserSelectXedit', [
  'dataCache',
  '$translate',
  function(dataCache, $translate) {
    return {
      restrict: 'E',
      template: `
        <a href=""
           editable-text="selected"
           e-uib-typeahead="user as user.label for user in filterUsers($viewValue)"
           e-typeahead-select-on-exact="true"
           e-typeahead-select-on-blur="false"
           e-typeahead-focus-first="false"
           e-typeahead-min-length="0"
           e-typeahead-on-select="$parent.$form.$submit()"
           e-autocomplete="off"
           e-select-on-focus
           e-placeholder="{{unassignedLabel}}"
           onbeforesave="save($data)"
           onaftersave="commitValue()"
           blur="submit"
           edit-disabled="disabled">
          <span ng-show="selected" ng-class="{'removed-user': selected && !selected.isActive}">{{selected.label}}</span>
          <i class="glyphicon glyphicon-pencil" ng-hide="selected"></i>
          <span ng-show="invalidUser()" class="text-red margin5L">
            <i class="fa fa-exclamation-triangle margin5R"></i>
            <span data-translate="Invalid user"></span>
          </span>
        </a>`,
      scope: {
        value: '=fieldValue',
        beforeSave: '&',
        afterSave: '&',
        disabled: '=?',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.unassignedLabel = $translate.instant('Unassigned');

          $scope.users = dataCache
            .getArray('user')
            .filter(x => x.isActive || !x.hidden)
            .map(({ userID, firstName, lastName, isActive }) => ({
              id: userID,
              label: (isActive ? '' : '⚠ ') + `${firstName} ${lastName}`,
              isActive,
            }))
            .sort(dynamicSort('label'));

          var findUser = function(id) {
            if (id == null) return null;
            return $scope.users.find(u => u.id === id) || null;
          };

          $scope.selected = findUser($scope.value);

          $scope.save = function(newValue) {
            if (!newValue || typeof newValue !== 'object') {
              $scope.selected = null;
              return $scope.beforeSave({ newValue: null });
            }
            $scope.selected = newValue;
            return $scope.beforeSave({ newValue: newValue.id });
          };

          $scope.commitValue = function() {
            $scope.value = $scope.selected ? $scope.selected.id : null;
          };

          $scope.filterUsers = function(query) {
            if (!query || query === ($scope.selected && $scope.selected.label)) {
              return $scope.users;
            }
            const lower = query.toLowerCase();
            return $scope.users.filter(u => u.label.toLowerCase().includes(lower));
          };

          $scope.invalidUser = function() {
            if (!$scope.value) return false;
            const user = dataCache.getObject('user')?.[$scope.value];
            if (!user) return false;
            return !!user.hidden;
          };

          $scope.$watch('value', newVal => {
            $scope.selected = findUser(newVal);
          });
        },
      ],
    };
  },
]);
